import * as z from 'zod';

export const dependentsSchema = z.object({
  name: z.string().min(1, { message: 'Campo obrigatório' }),
  birthDate: z
    .string()
    .min(1, { message: 'Campo obrigatório' })
    .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, { message: 'Data inválida' }),
  civilStatus: z.string().min(1, { message: 'Campo obrigatório' }),
  gender: z.string().min(1, { message: 'Campo obrigatório' }),
  parentage: z.string().min(1, { message: 'Campo obrigatório' }),
  cpf: z.string().optional(),
  mothersName: z.string().min(1, { message: 'Campo obrigatório' }),
  plano: z.string(),
  plano_vl: z.string(),
});
